import { Component } from '@angular/core';
import { LeftPanelWidgetLibraryComponent } from '../left-panel-widget-library/left-panel-widget-library.component';

@Component({
  selector: 'app-snapshot',
  templateUrl: './snapshot.component.html',
  styleUrls: ['./snapshot.component.css']
})
export class SnapshotComponent {

}
